import { useCrmSelection_AllCoveredInvestorFirmsMappedToCmgEntityKeyQuery } from '../graphql/__generated__';

export const useGetAllCoveredInvestorFirmsMappedToCmgEntityKey = (
  options: Parameters<typeof useCrmSelection_AllCoveredInvestorFirmsMappedToCmgEntityKeyQuery>[0]
) =>
  useCrmSelection_AllCoveredInvestorFirmsMappedToCmgEntityKeyQuery({
    ...options,
    fetchPolicy: 'no-cache',
  });
